import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";

const ProductSales = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const [productId, setProductId] = useState(0);

  const [productData, setProductData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getProductSales } = useHttp();

  const fillProductSales = (employeeId, productId, getType = "") => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }
    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }
    if (productId > 0) {
      urlfilter += `&productId=${productId}`;
    }
    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/agriPromoterProductwiseTarget/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getProductSales(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } 
        else {
          console.log("d",data);
          setCurrentPage(1)
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillProductSales(0, 0, "");
  }, [getProductSales]);

  const customHeaders = [
    "Promoter Id",
    "Agri Promoter Name",
    "From Date",
    "To Date",
    "State",
    "LGA",
    "Product",
    "Target Quantity",
    "Actual Sales",
    "Unit",
  ];
  const fieldsToExport = [
    "promoterId",
    "employeeName",
    "fromDate",
    "toDate",
    "state",
    "lga",
    "productName",
    "targetQty",
    "actualProductSales",
    "unitAbbreviation",
  ];

  const handleExportExcel = () => {
    const filename = "AgriPromoterProductwiseTarget.xlsx";
    //console.log(fieldsToExport, customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getProduct } = useHttp();

  const ProductDetail = () => {
    getProduct(
      {
        url: `/api/FillAfsProductListForAgriPromoter/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("product", data);
        // var emplist = data;

        setProductData(data);
      }
    );
  };

  useEffect(() => {
    ProductDetail(0);
  }, [getProduct]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Product Sales Target V/s Actual Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Product Name</label>
                  <select
                    id="productId"
                    className="form-control"
                    ref={(el) => (frmRef.current["productId"] = el)}
                    value={productId}
                    onChange={(e) => {
                      setProductId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {productData &&
                      productData.map((x) => (
                        <option key={x.productId} value={x.productId}>
                          {x.productName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillProductSales(employeeId,productId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12 col-lg-12 col-sm-12 col-12 col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Promoter Id</th>
                          <th>Agri Promoter Name</th>
                          <th>From Date</th>
                          <th>To Date Name</th>
                          <th>State</th>
                          <th>LGA</th>

                          <th>Product Name</th>

                          <th>Target Quantity</th>
                          <th>Actual Sales</th>
                          <th>Unit</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            const products =
                              itm.fieldDetailProducts &&
                              Array.isArray(itm.fieldDetailProducts) &&
                              itm.fieldDetailProducts.length > 0
                                ? itm.fieldDetailProducts
                                : [null];

                            return products.map((prod, j) => (
                              <tr key={`${i}-${j}`} className="tablerowview">
                                <td>{i + 1}</td>
                                <td>{itm.promoterId || ""}</td>
                                <td>{itm.employeeName || ""}</td>
                                <td>{itm.fromDate || ""}</td>
                                <td>{itm.toDate || ""}</td>
                                <td>{itm.state || ""}</td>
                                <td>{itm.lga || ""}</td>

                                <td>{itm.productName || ""}</td>
                                <td>{itm.targetQty || ""}</td>
                                <td>{itm.actualProductSales || ""}</td>
                                <td>{itm.unitAbbreviation || ""}</td>
                              </tr>
                            ));
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ProductSales;
